import React from 'react';

import { useSystemUserApi } from '../../../api/system-user/useSystemUserApi';

import ForgotPassword from '../../../components/screens/auth/forgot-password/ForgotPassword';

const ForgotPasswordContainer = () => {
  const { initiatePasswordReset: initiatePasswordResetRequest } = useSystemUserApi();

  const initiatePasswordReset = (email: string, mobileNumber: string, onSuccess: () => void) => {
    initiatePasswordResetRequest({ email, mobileNumber }, onSuccess);
  };

  return <ForgotPassword initiatePasswordReset={initiatePasswordReset} />;
};

export default ForgotPasswordContainer;
